
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/acoustic",
      function () {
        return require("private-next-pages/destinations/acoustic.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/acoustic"])
      });
    }
  